import InfoPage from '@/components/InfoPage';
import { Play, User, Building2 } from 'lucide-react';

const Demo = () => {
  return (
    <InfoPage title="Demonstração">
      <div className="space-y-8">
        <section>
          <h2 className="text-2xl font-semibold mb-4" style={{ color: '#302681' }}>Como Usar o ParkingSpot</h2>
          <p className="text-gray-700 mb-6">
            Assista aos vídeos de demonstração abaixo para aprender a usar todas as funcionalidades do ParkingSpot.
          </p>
        </section>

        <section>
          <div className="bg-gradient-to-br from-blue-50 to-purple-50 p-8 rounded-2xl border-2 border-[#302681]">
            <div className="flex items-center mb-4">
              <User className="w-8 h-8 mr-3" style={{ color: '#302681' }} />
              <h3 className="text-2xl font-bold" style={{ color: '#302681' }}>Para Motoristas</h3>
            </div>
            
            <div className="space-y-4 text-gray-700">
              <div className="bg-white p-6 rounded-lg">
                <h4 className="font-semibold mb-2">Passo 1: Abra o ParkingSpot</h4>
                <p className="text-sm">Acesse o site e permita o acesso à sua localização para ver estacionamentos próximos.</p>
              </div>
              
              <div className="bg-white p-6 rounded-lg">
                <h4 className="font-semibold mb-2">Passo 2: Explore o Mapa</h4>
                <p className="text-sm">Veja todos os estacionamentos disponíveis no mapa. As cores indicam o tipo: azul (coberto), verde (descoberto), amarelo (misto).</p>
              </div>
              
              <div className="bg-white p-6 rounded-lg">
                <h4 className="font-semibold mb-2">Passo 3: Escolha um Estacionamento</h4>
                <p className="text-sm">Clique nos marcadores para ver detalhes: vagas disponíveis, preços e horários.</p>
              </div>
              
              <div className="bg-white p-6 rounded-lg">
                <h4 className="font-semibold mb-2">Passo 4: Navegue até o Local</h4>
                <p className="text-sm">Use o mapa interativo para se dirigir ao estacionamento escolhido.</p>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="bg-gradient-to-br from-red-50 to-orange-50 p-8 rounded-2xl border-2 border-[#831D1C]">
            <div className="flex items-center mb-4">
              <Building2 className="w-8 h-8 mr-3" style={{ color: '#831D1C' }} />
              <h3 className="text-2xl font-bold" style={{ color: '#831D1C' }}>Para Proprietários</h3>
            </div>
            
            <div className="space-y-4 text-gray-700">
              <div className="bg-white p-6 rounded-lg">
                <h4 className="font-semibold mb-2">Passo 1: Crie sua Conta</h4>
                <p className="text-sm">Clique em "Entrar / Cadastrar" e crie uma conta gratuitamente usando email ou Google.</p>
              </div>
              
              <div className="bg-white p-6 rounded-lg">
                <h4 className="font-semibold mb-2">Passo 2: Acesse o Dashboard</h4>
                <p className="text-sm">Após o login, acesse o Dashboard do Proprietário no menu.</p>
              </div>
              
              <div className="bg-white p-6 rounded-lg">
                <h4 className="font-semibold mb-2">Passo 3: Adicione seu Estacionamento</h4>
                <p className="text-sm">Clique em "Adicionar Estacionamento" e preencha todos os dados: nome, endereço, localização, preços, tipo e vagas.</p>
              </div>
              
              <div className="bg-white p-6 rounded-lg">
                <h4 className="font-semibold mb-2">Passo 4: Gerencie suas Vagas</h4>
                <p className="text-sm">Atualize o número de vagas disponíveis em tempo real diretamente no dashboard.</p>
              </div>
              
              <div className="bg-white p-6 rounded-lg">
                <h4 className="font-semibold mb-2">Passo 5: Edite Informações</h4>
                <p className="text-sm">Use o botão "Editar" para atualizar preços, horários ou qualquer outra informação do seu estacionamento.</p>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded">
          <h3 className="font-semibold mb-2 flex items-center">
            <Play className="w-5 h-5 mr-2" />
            Experimente Agora!
          </h3>
          <p className="text-gray-700">
            A melhor forma de aprender é experimentando. Volte à página inicial e comece a usar o ParkingSpot agora mesmo!
          </p>
          <a 
            href="/"
            className="inline-block mt-4 px-6 py-2 rounded-lg text-white font-medium"
            style={{ backgroundColor: '#302681' }}
          >
            Ir para o Mapa
          </a>
        </section>
      </div>
    </InfoPage>
  );
};

export default Demo;
